module.exports = __webpack_public_path__ + "static/img/b2de9c82d158ccbfe5a695dc12d8bc3eb1354139.4e11b3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/logo/b2de9c82d158ccbfe5a695dc12d8bc3eb1354139.jpg
// module id = crrQ
// module chunks = 0